import React from "react";

/**
 * Phases sourced from peiarchitect.com/contact:
 *   "predesign, schematic studies, municipal approvals, design development,
 *    construction drawings, engineering and special consultant co-ordination,
 *    and field review"
 */
const STEPS = [
  {
    n: "01",
    title: "Predesign & Schematic Studies",
    body:
      "We begin by studying the site and understanding the surroundings — the land, the light, the way a place is used through a full Island year. Schematic studies grow out of that listening.",
  },
  {
    n: "02",
    title: "Design Development & Municipal Approvals",
    body:
      "Design development refines massing, orientation, and material palette. We develop 3D models to show how sunlight will affect spaces and how finishes, materials, furniture, and landscaping will behave together. Municipal approvals run alongside.",
  },
  {
    n: "03",
    title: "Construction Drawings & Consultant Coordination",
    body:
      "Construction drawings carry the detail a builder needs and the clarity a municipality expects. We coordinate engineering and special consultants so every discipline arrives at the site aligned.",
  },
  {
    n: "04",
    title: "Field Review",
    body:
      "We stay close through construction — visiting the site, answering questions, reviewing progress against the drawings, and holding the design intent together until the keys turn.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="sb-process py-28 md:py-40 relative"
    >
      <div className="container-editorial">
        <div className="reveal mb-20 md:mb-28 max-w-3xl">
          <p
            className="text-[11px] uppercase font-body mb-6"
            style={{ color: "#3a7d7b", letterSpacing: "0.36em" }}
          >
            — Our Process
          </p>
          <h2
            className="font-display leading-[1.02] tracking-[-0.018em]"
            style={{ fontSize: "clamp(2.25rem, 5vw, 4.75rem)", fontWeight: 400 }}
          >
            Four movements, carried <em className="italic">patiently</em>.
          </h2>
        </div>

        <ol>
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="sb-process-step reveal grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-12 md:py-20 items-start relative"
              style={{ borderTopWidth: i === 0 ? "0" : "1px" }}
            >
              <div className="md:col-span-5 relative">
                <span
                  aria-hidden
                  className="sb-process-numeral font-display italic block leading-[0.85] select-none"
                  style={{
                    fontSize: "clamp(7rem, 14vw, 14rem)",
                    letterSpacing: "-0.04em",
                    fontWeight: 300,
                  }}
                >
                  {s.n}
                </span>
              </div>
              <div className="md:col-span-7 md:pt-8">
                <p
                  className="text-[10px] uppercase font-body mb-4"
                  style={{ color: "#3a7d7b", letterSpacing: "0.36em" }}
                >
                  Phase {s.n}
                </p>
                <h3
                  className="font-display mb-6 leading-[1.05] tracking-[-0.01em]"
                  style={{ fontSize: "clamp(1.75rem, 3.2vw, 3rem)", fontWeight: 400 }}
                >
                  {s.title}
                </h3>
                <p className="sb-process-body font-body text-base md:text-[17px] leading-[1.85] max-w-xl">
                  {s.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Process;
